export const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

export const asRecordArray = (value: unknown): Record<string, unknown>[] => {
  if (!Array.isArray(value)) return []
  return value.filter(isRecord)
}

export const valueAtPath = (value: unknown, path: string): unknown =>
  path.split('.').reduce<unknown>((current, key) => {
    if (!isRecord(current)) return undefined
    return current[key]
  }, value)

export const recordAtPath = (
  value: unknown,
  path: string
): Record<string, unknown> | null => {
  const found = valueAtPath(value, path)
  return isRecord(found) ? found : null
}

export const firstRecordAt = (
  response: Record<string, unknown>,
  paths: string[]
): Record<string, unknown> | null => {
  for (const path of paths) {
    const found = recordAtPath(response, path)
    if (found) return found
  }
  return null
}

export const arrayAtPath = (
  value: unknown,
  path: string
): Record<string, unknown>[] => asRecordArray(valueAtPath(value, path))

export const firstArrayAt = (
  response: Record<string, unknown>,
  paths: string[]
): Record<string, unknown>[] => {
  for (const path of paths) {
    const found = arrayAtPath(response, path)
    if (found.length > 0) return found
  }
  return []
}
